"use client";

import { CalendarDotsIcon } from "@phosphor-icons/react/dist/ssr";
import { useTranslations } from "next-intl";

import { Box } from "@/components/ui/box";
import { useUser } from "@/hooks/usePermissions";
import { useWorkflow } from "@/queries/useWorkflow";

import { useDeadlineAvi } from "../queries/useDeadlineAvi";
import { useRecentAvi } from "../queries/useRecentAvi";
import { DeadlineCard } from "./deadlineCard";
import { HomePanelSection } from "./homePanelSection";
import { RecentAviTable } from "./recentAviTable";
import { WorkflowAviCard } from "./workflowAviCard";

export function HomeAviPanel() {
  const t = useTranslations("home");
  const user = useUser();
  const params = { account_id: user.account_id, role: user.role };

  const { data: recentAvis, isError: recentError, isLoading: recentLoading } = useRecentAvi(params);
  const {
    data: deadlineData,
    isError: deadlineError,
    isLoading: deadlineLoading,
  } = useDeadlineAvi(params);
  const {
    data: workflowData,
    isError: workflowError,
    isLoading: workflowLoading,
  } = useWorkflow(params);

  return (
    <Box className="flex min-h-0 min-w-0 flex-[4_4_0] flex-col self-stretch rounded-4xl bg-white">
      <div className="mx-1 mt-6 mb-6 flex min-h-0 flex-1 flex-col overflow-y-auto">
        <div className="flex w-full shrink-0 items-start border-b border-neutral-100 px-6 pt-0 pb-3 xl:pb-4.5">
          <h1 className="font-heading text-2xl leading-7 font-medium text-neutral-950">
            {t("greeting", { name: user.name })}
          </h1>
        </div>

        <div className="flex w-full flex-1 flex-col justify-between px-6 pt-4">
          <HomePanelSection
            isLoading={recentLoading}
            isError={recentError}
            loadingText={t("panel.recentAvi.loading")}
            errorText={t("panel.recentAvi.error")}
            showDivider
          >
            <RecentAviTable items={recentAvis} />
          </HomePanelSection>

          <HomePanelSection
            isLoading={deadlineLoading}
            isError={deadlineError}
            loadingText={t("panel.deadline.loading")}
            errorText={t("panel.deadline.error")}
            showDivider
          >
            <DeadlineCard data={deadlineData} icon={<CalendarDotsIcon size={24} />} />
          </HomePanelSection>

          <HomePanelSection
            isLoading={workflowLoading}
            isError={workflowError}
            loadingText={t("panel.workflow.loading")}
            errorText={t("panel.workflow.error")}
          >
            <WorkflowAviCard data={workflowData} />
          </HomePanelSection>
        </div>
      </div>
    </Box>
  );
}
